import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SideMenuService } from 'src/app/services/side-menu.service';
import { Router, NavigationExtras } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AppService } from 'src/app/app.service';
import { AppDataService } from 'src/app/services/app-data.service';
import { MenuController, AlertController } from '@ionic/angular';
import { InAppBrowser, InAppBrowserOptions } from "@ionic-native/in-app-browser/ngx";
import { ignoreElements } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnInit {
  appVersion = '';
  routeId: any = '';

  navigationExtras: NavigationExtras = {};

  appPages = new BehaviorSubject([]);

  isLoginOnStart = false;
  isLoginInMenu = false;
  logoUrl: string | undefined = undefined;
  sideMenuImage: any;
  selectedLanguageKey = 'bg';
  // firstRoute = '';
  lstLanguage: any
  get bgImage() {
    return true;
  }
  version: any = environment.version;
  get iconList() {
    return true;
  }
  systemLanguage = new BehaviorSubject([]);
  constructor(
    public menu: SideMenuService,
    private router: Router,
    public authService: AuthenticationService,
    private appService: AppService,
    private appData: AppDataService,
    public menuCtrl: MenuController,
    private iab: InAppBrowser,
    private alrtCtrl: AlertController,
  ) {
    // init side menu

    // this.menu.initSideMenu();
    this.appService.logoUrl.subscribe(url => {
      this.logoUrl = url;
    });
  }

  async ngOnInit() {
    this.appService.sytstemSettingData.subscribe((val) => {
      if (val && val.language && val.language.language) {
        this.lstLanguage = val.language.language;
        this.selectedLanguageKey = val.language.default ? val.language.default : localStorage.getItem("lang") ? localStorage.getItem("lang") : 'bg';
        this.menu.currentLangKey = this.selectedLanguageKey;
      }
      if (val && (val.slide_out_image || val.slide_out_menu_icon_color)) {
        if (val.slide_out_image) {
          this.sideMenuImage = val.slide_out_image.data.full_url;
        }
      }
      if (Object.keys(val).length) {
        this.initilizeData();
      }
      if (val) {
        // this.menu.initSideMenu();
      }
    });
    const systemLanguageSnap = await this.appData.getSystemLanguagesData(
      'system_languages'
    );
    // get System Language Data from Data service
    this.systemLanguage.next(this.appData.systemLanguages[0]);
  }

  async initilizeData() {
    this.isLoginInMenu = this.appService.systemSettings.login_in_menu;
    this.isLoginOnStart = this.appService.systemSettings.login_on_start;

    const firstRoute = this.isLoginOnStart
      ? 'login'
      : this.appService.systemSettings?.homepage;

    if (firstRoute) {
      this.menu.homePageUrl = this.appService.systemSettings?.homepage;
    } else {
      this.showAlert('Reload App', 'Something went wrong, Restart the app');
    }
    // const logoID = this.appService.systemSettings.logo?.id;
    // if (logoID) {
    //   this.getLogo(logoID);
    // }
    // set selected language language
    this.selectedLanguageKey = this.selectedLanguageKey ? this.selectedLanguageKey : this.menu.currentLangKey;
  }

  async showAlert(title, message) {
    // const alertRet = await Modals.alert({
    //   title,
    //   message,
    // });
    const alert = await this.alrtCtrl.create({
      header: title,
      message: message,
      buttons: [{
        text: 'Close'
      }]
    })
    alert.present();
  }
  logout() {
    this.authService.logoutUser()
    // this.appService.canShowMenu = false;
  }
  navigateToModule(moduleData, index) {
    if (moduleData && moduleData.www_url) {
      let browserOptions: InAppBrowserOptions = {
        zoom: "no",
        location: "no",
        toolbar: "yes",
        toolbarcolor: "#FFFFFF"
      };
      this.iab.create(
        moduleData.www_url,
        "_blank",
        browserOptions
      );
    } else {
      this.menu.selectedIndex = index;

      this.navigationExtras.state = moduleData.collections;
      this.navigationExtras.replaceUrl = true;

      this.router.navigate([`/${moduleData.url}`], this.navigationExtras);
    }
  }
  /*
    logout() {
      console.log('Logout Clicked');
      this.authService
        .logoutUser()
        .then(() => {
          this.appService.canShowMenu = false;
          this.router.navigate(['/login'], { replaceUrl: true });
        })
        .catch((error) => {
          console.log('Error While Logging out the user', error);
        });
    } */

  isMenuAvailable(menuData) {
    if (!this.authService.isLoggedIn) {
      if (this.isLoginOnStart) {
        return (
          menuData.visible && this.checkUserRole(menuData.require_role)
          // menuData.require_role === this.menu.currentLoggedInUserRole
        );
      } else {
        // return menuData.visible && menuData.require_login === this.isLoginOnStart;
        return menuData.visible && menuData.require_login == false;
      }
    } else {
      return menuData.visible && this.checkUserRole(menuData.require_role)
    }
  }
  checkUserRole(userRole) {
    if (userRole === null || userRole === undefined || userRole === '' || this.menu.currentLoggedInUserRole === 'Administrator') {
      return true;
    } else {
      return userRole === this.menu.currentLoggedInUserRole;
    }
  }
  getLogo(id) {
    this.appData.getFile(id).then((res: any) => {
      if (res.data) {
        this.appService.logoUrl.next(res.data.data.full_url);
      }
    }).then((err: any) => {
      if (err) {
        // console.log('logo err', err);
      }
    });
  }

  changeSystemLanguage(e) {
    let langKey = e.target.value;
    this.menu.setCurrentAppLanguage(langKey);
    this.menu.initSideMenu();

    let pages = this.menu.appPages.getValue();
    // console.log(pages, this.menu.homePageUrl)
    let homepageDataIdx = pages.findIndex((p, i) => p.url == this.menu.homePageUrl);
    // console.log(homepageDataIdx)
    // this.menuCtrl.close();
    // this.navigateToModule(pages[homepageDataIdx], homepageDataIdx);

    // this.appData.presentLoader({
    //   message: 'Reloading...',
    // });
    // this.router.navigate([`${this.menu.homePageUrl}`], {
    //   replaceUrl: true,
    // });
    // setTimeout(() => {
    //   this.appData.dismissLoader();
    // }, 100);
    // console.log('this.menu.homePageUrl', this.menu.homePageUrl);
  }

  changeLanguage() {
    // window.location.reload();
  }
}
